import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';

import { NoteDetails, NoteTarget } from 'generated/graphql';

import { GetNotesService } from 'app/note/get-notes.service';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

export interface NoteDialogData {
  campaignId: string;
  targetType: NoteTarget;
  targetId: string;
  noteType: 'text' | 'date' | 'number';
  heading: string;
  hideNotes?: boolean;
  keepOpenAfterSave?: boolean;
}

@Component({
  selector: 'app-note-dialog-component',
  templateUrl: './note-dialog.component.html'
})
export class NoteDialogComponent extends WithDisposableSubject()
  implements OnInit {
  notes: NoteDetails.Fragment[];

  static open(dialog: MatDialog, config: MatDialogConfig<NoteDialogData>) {
    return dialog.open(NoteDialogComponent, config);
  }

  constructor(
    public dialogRef: MatDialogRef<NoteDialogComponent>,
    private _getNotesService: GetNotesService,
    @Inject(MAT_DIALOG_DATA) public data: NoteDialogData) {
    super();
  }

  ngOnInit() {
    this._getNotesService.getNotes(
      this.data.targetType,
      this.data.targetId,
      this.data.campaignId
    )?.pipe(
      takeUntil(this.disposer)
    ).subscribe((notes) => {
      this.notes = notes;
    });
  }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  noteAdded(event: any) {
    if (this.data.keepOpenAfterSave) {
      return;
    }
    this.close(event);
  }

}
